<template>

    <v-footer  class="foot toolbar" app >

        <!--1101022 by IvyLin 設定參數檔 BASEINFO DEF_SHORTCUT	首頁,mdi-home-outline,IndexSHS/{"divCode":""}/{"zone":""}-->
        <template v-if="footerList.length>0">

            <v-bottom-navigation
                    class="toolbar dense"
                    absolute
                    :style="{height:isHeightFooter==true?'49px':'40px'}"
                    v-model="activeBtn">

                <!-- -->
                <v-row  @click="routerParamLink(index,item)" v-for="(item,index) in footerList" :key="index"  :style="{cursor:'pointer',marginLeft:index==0?'0px':'auto',border:'1px solid var(--v-toolbar-base)'}"

                        :class="['row--dense mr-0 xs2 sm2 md2 lg2 justify-space-around','elevation-2',activeBtn==index?'activeBtn':'unActiveBtn']">
                    <v-btn  dark
                             :value="index" small >
                        <span :class="[activeBtn==index?'activeBtnText':'unActiveBtnText']">{{item.title}}</span>
                        <v-icon  v-if="item.icon!==' '&&item.icon!==''">{{item.icon}}</v-icon>
                    </v-btn>
                </v-row>

            </v-bottom-navigation>

        </template>

        <!--沒有設定參數檔 原有的程式流程 1101022 By IvyLin註解-->
        <v-bottom-navigation
                v-else
                dense
                class="toolbar tr-for-weihao"
                absolute
                style="height: auto"
                v-model="activeBtn"

        >
            <v-btn style="display: none" value="-1" small >

            </v-btn>
            <v-btn :class="['mr-0 xs2 sm2 md2 lg2 justify-space-around','elevation-2',activeBtn=='0'?'activeBtn':'unActiveBtn']" :style="{display: hospTheme==''?'none':'block'}" value="0" small @click="routeLink(hospTheme)">
                <span :class="[activeBtn=='0'?'activeBtnText':'unActiveBtnText']">醫院簡介</span>
                <v-icon>mdi-hospital-building</v-icon>
            </v-btn>

            <v-btn :class="['mr-0 xs2 sm2 md2 lg2 justify-space-around','elevation-2',activeBtn=='1'?'activeBtn':'unActiveBtn']" value="1" small @click="routeLink(clinicTheme)"
                   :style="{cursor:'pointer',border:'1px solid var(--v-toolbar-base)',padding: '3px'}">
                <span :class="[activeBtn=='1'?'activeBtnText':'unActiveBtnText']">掛號</span>
                <v-icon>mdi-heart</v-icon>
            </v-btn>

            <v-btn :class="['mr-0 xs2 sm2 md2 lg2 justify-space-around','elevation-2',activeBtn=='2'?'activeBtn':'unActiveBtn']" value="2" small @click="routeLink('ClinicNoSearch')"
                   :style="{cursor:'pointer',border:'1px solid var(--v-toolbar-base)',padding: '3px'}">
                <span :class="[activeBtn=='2'?'activeBtnText':'unActiveBtnText']">看診進度</span>
                <v-icon>mdi-counter</v-icon>
            </v-btn>

            <v-btn  value="3" small @click="routeLink('RegSearchCancel')"
                    :class="['mr-0 xs2 sm2 md2 lg2 justify-space-around','elevation-2',activeBtn=='3'?'activeBtn':'unActiveBtn']"
                    :style="{cursor:'pointer',border:'1px solid var(--v-toolbar-base)',padding: '3px'}">
                <span :class="[activeBtn=='3'?'activeBtnText':'unActiveBtnText']">查詢/取消看診</span>
                <v-icon>mdi-cloud-search-outline</v-icon>
            </v-btn>
        </v-bottom-navigation>
    </v-footer>

</template>

<script>
    export default {
        name: "AppFooter",
        data() {
            return {
                activeBtn: "-1",
                clinicTheme:'ClinicB',
                hospTheme:'',
                footerSetting:[],
                footerList:[],
                isHeightFooter:false,
            }
        },
        created(){
            this.axios_getSysTheme();
            this.axios_getDEF_SHORTCUT();
        },
        watch:{
            '$route' (to) { // to ,from 指定button點選位置
                if(this.footerList.length==0){
                    switch (to.name){
                        case 'HospA': //醫院介紹A
                        case 'HospB': //醫院介紹B
                        case 'HospC': //醫院介紹C
                        case 'HospD': //醫院介紹D
                            this.activeBtn = "0";
                            break;
                        case 'ClinicA': //掛號A
                        case 'ClinicB': //掛號B
                        case 'ClinicC': //掛號C
                        case 'ClinicD': //掛號D
                        case 'DocDivRegSearch': //掛號 科別醫師掛號
                            this.activeBtn = "1";
                            break;
                        case 'ClinicNoSearch': //看診狀態
                            this.activeBtn = "2";
                            break;
                        case 'RegSearchCancel': //查詢/取消看診
                            this.activeBtn = "3";
                            break;
                        default:
                            this.activeBtn = -1;
                    }
                }


            }
        },

        methods:{
            routeLink(name){
                this.$router.push({name:name}).catch(() => {
                })
            },
            routerParamLink(index,item){
                this.activeBtn = index;
                this.$router.push({name:item.name, params:item.param,query:item.query});
            },
            setFooterValue(valueList){
                let footerList = [];
                for(let value in valueList){
                    if(valueList[value]!==null){
                        let value1Array = valueList[value].split(',');
                        let pathList = value1Array[2].split('/')
                        footerList.push({
                            title:value1Array[0],
                            icon:value1Array[1],
                            name:pathList[0],
                            param:JSON.parse(pathList[1]),
                            query:JSON.parse(pathList[2])
                        })
                    }
                }
                return footerList;

            },
            splitFooter(footerSetting){
                let footerList = [];
                let valueList = [];
                for(let i=0;i<4;i++){
                    valueList.push(footerSetting['value'+(i+1)])
                }
                footerList = this.setFooterValue(valueList);

               /** let value1 = footerSetting.value1;
                let value2 = footerSetting.value2;
                let value3 = footerSetting.value3;
                let value4 = footerSetting.value4;

                if(value1!==null){
                    let value1Array = value1.split(',');
                    let pathList = value1Array[2].split('/')
                    footerList.push({
                        title:value1Array[0],
                        icon:value1Array[1],
                        name:pathList[0],
                        param:JSON.parse(pathList[1]),
                        query:JSON.parse(pathList[2])
                    })

                }
                if(value2!==null){
                    let value2Array = value2.split(',');
                    let pathList = value2Array[2].split('/')
                    footerList.push({
                        title:value2Array[0],
                        icon:value2Array[1],
                        name:pathList[0],
                        param:JSON.parse(pathList[1]),
                        query:JSON.parse(pathList[2])
                    })
                }
                if(value3!==null){
                    let value3Array = value3.split(',');
                    let pathList = value3Array[2].split('/')
                    footerList.push({
                        title:value3Array[0],
                        icon:value3Array[1],
                        name:pathList[0],
                        param:JSON.parse(pathList[1]),
                        query:JSON.parse(pathList[2])
                    })
                }
                if(value4!==null){
                    let value4Array = value4.split(',');
                    let pathList = value4Array[2].split('/')
                    footerList.push({
                        title:value4Array[0],
                        icon:value4Array[1],
                        name:pathList[0],
                        param:JSON.parse(pathList[1]),
                        query:JSON.parse(pathList[2])
                    })
                }**/
                return footerList;
                // this.$router.push({name: this.clinicTheme, params:{divCode:this.regPage},query:{zone:this.$route.query.zone}});
            },
            //查詢樣式 1100113
            axios_getSysTheme (){ //查詢樣式theme設定檔
                let url = '';
                this.clinicTheme = 'ClinicA';
                this.hospTheme = ''
                url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/BASEINFO/THEME";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.clinicTheme = response.data.resultSet[0].value3;
                        this.hospTheme = response.data.resultSet[0].value1==''||response.data.resultSet[0].value1==undefined?'':response.data.resultSet[0].value1;

                    }else{
                        this.clinicTheme = 'ClinicA';
                        this.hospTheme = ''
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.clinicTheme = 'ClinicA';
                        this.hospTheme = ''
                    } catch(err) {
                        this.clinicTheme = 'ClinicA';
                        this.hospTheme = ''
                    }

                });
            },
            axios_getDEF_SHORTCUT (){ //查詢底部footer 設定
                let url = '';
                this.footerSetting = {};
                this.footerList = [];
                url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/BASEINFO/DEF_SHORTCUT";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.footerSetting = response.data.resultSet[0];
                        this.footerList = this.splitFooter(this.footerSetting);
                        let isHeightFooter = this.footerList.some(function(item){
                            return item.icon.length > 0;    // 找出icon長度大於0的
                        });
                        this.isHeightFooter = isHeightFooter;
                        this.activeBtn = 0;

                    }else{
                        this.footerSetting = {};
                        this.footerList = [];
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.footerSetting = {};
                        this.footerList = [];
                    } catch(err) {
                        this.footerSetting = {};
                        this.footerList = [];
                    }
                });
            },
        }
    }
</script>

<style scoped>

    /*.activeBtn{*/
             /*color: white!important;*/
             /*background: var(--v-toolbar-base)!important;*/
             /*!*border: 1px solid gray;*!*/
         /*}*/


</style>